import { MapPin } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const tracksSchema = defineSchema({
  id: 'tracks',
  title: 'filter.schema.tracks.title',
  subtitle: 'filter.schema.tracks.subtitle',
  defaultField: 'name',
  fields: {
    name: {
      key: 'name',
      label: 'filter.field.trackName',
      type: 'text',
      icon: MapPin,
      placeholder: 'filter.placeholder.track',
      description: 'filter.desc.track',
      example: 'name:Wohlen',
    },
  },
  examples: [
    { q: 'Wohlen', desc: 'filter.example.findWohlen' },
    { q: 'name:"Kartbahn Wohlen"', desc: 'filter.example.exactTrack' },
  ],
});

